import { CircularProgress, Alert } from '@mui/material';
import axios, { AxiosResponse } from 'axios';
import { useState, useContext, useEffect } from 'react';
import { API_ENDPOINT } from '../../../configurations/global.config';
import { useSnackBar } from '../../../contexts/snackbar';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { DriverType } from '../../../interfaces/delivery-company/drivers';
import { ErrorsFlattenner } from '../errors-flattenner/errors-flattenner';
import { UserType } from '../../../enums/users';

export const WhatsAppConnectionAuthCode = ({
  driver,
}: {
  driver: DriverType;
}) => {
  const [authCode, setAuthCode] = useState<string | null>(null);
  const { user, config } = useContext(AuthContext);
  const [response, setResponse] = useState<AxiosResponse>();
  const [message, setMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const { showMessage } = useSnackBar();

  const fetchAuthCode = async () => {
    setIsLoading(true);
    setMessage('');
    setResponse(undefined);
    const endpoint =
      user?.type === UserType.DRIVER
        ? `${API_ENDPOINT}/api/v1/whatsapp/auth-code/`
        : `${API_ENDPOINT}/api/v1/whatsapp/driver/${driver.id}/auth-code/`;
    try {
      const response = await axios.get<{ code: string }>(endpoint, config);
      setAuthCode(response.data.code);
      setResponse(response);
      console.log('response = ', response);
      showMessage('Authentication Code Received');
    } catch (e) {
      if (axios.isAxiosError(e)) {
        setResponse(e.response);
        setMessage(
          'Failed to get authentication code: ' + e.response?.statusText
        );
      } else {
        setMessage(
          'Failed to get authentication code, please try again later.'
        );
      }
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchAuthCode();
  }, []);

  return (
    <div style={{ width: '100%', textAlign: 'center' }}>
      {isLoading ? (
        <>
          Please keep this dialog open while we get the authentication code.{' '}
          <br /> <br />
          <CircularProgress />
        </>
      ) : (
        <>
          {message != '' && (
            <>
              <Alert
                severity={
                  response && response.status >= 200 && response.status < 300
                    ? 'success'
                    : 'error'
                }
              >
                <>
                  {message}

                  {response && response.status >= 300 && (
                    <ErrorsFlattenner rawErrors={response.data} />
                  )}
                </>
              </Alert>
              <br />{' '}
            </>
          )}

          <br />

          {authCode ? (
            <>
              <Alert severity="info">
                {user?.type == UserType.DRIVER ? (
                  <>
                    Please use the code below to link your whatsapp to the
                    application.
                  </>
                ) : (
                  <>
                    Please share the code below with {driver.name} so they can
                    use it to connect their whatsapp account.
                  </>
                )}
              </Alert>
              <br />
              Authentication Code: <b>{authCode}</b>
            </>
          ) : (
            <Alert severity="error">
              An error occurred, please try again later.
            </Alert>
          )}
        </>
      )}
    </div>
  );
};
